/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_ArticlesInputs */

const en_page_title_articles = /** @type {(inputs: Page_Title_ArticlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles`)
};

const nl_page_title_articles = /** @type {(inputs: Page_Title_ArticlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikelen`)
};

/**
* | output |
* | --- |
* | "Articles" |
*
* @param {Page_Title_ArticlesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_articles = /** @type {((inputs?: Page_Title_ArticlesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_ArticlesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_articles(inputs)
	return en_page_title_articles(inputs)
});